webpackJsonp([196538333293080],{

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 33.3%;\n  padding: 1%;\n'], ['\n  width: 33.3%;\n  padding: 1%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-radius: 1%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n'], ['\n  border-radius: 1%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  border-radius: 1%;\n  margin: 0;\n  vertical-align: bottom;\n'], ['\n  border-radius: 1%;\n  margin: 0;\n  vertical-align: bottom;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardWrapper = _styledComponents2.default.div(_templateObject);
	var Card = _styledComponents2.default.div(_templateObject2);
	var CardImage = _styledComponents2.default.img(_templateObject3);
	var ProgramCard = function ProgramCard(_ref) {
	  var title = _ref.title,
	      summary = _ref.summary,
	      thumbnailUrl = _ref.thumbnailUrl,
	      programId = _ref.programId;
	
	  return _react2.default.createElement(
	    CardWrapper,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: '/program/' + programId },
	      _react2.default.createElement(
	        Card,
	        null,
	        _react2.default.createElement(CardImage, { src: thumbnailUrl, alt: title })
	      )
	    )
	  );
	};
	
	exports.default = ProgramCard;
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgramCard = __webpack_require__(395);
	
	var _ProgramCard2 = _interopRequireDefault(_ProgramCard);
	
	var _theme = __webpack_require__(17);
	
	var _layout = __webpack_require__(16);
	
	var _reactHelmet = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgramsPage = function ProgramsPage(props) {
	  var programs = props.data.allProgram.edges.map(function (edge) {
	    return edge.node;
	  });
	  var meta = props.meta;
	
	  return _react2.default.createElement(
	    _layout.FrameContainer,
	    null,
	    _react2.default.createElement(_reactHelmet.Helmet, { title: meta.title + "/番組一覧", meta: [{ name: 'description', content: meta.description }] }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\u756A\u7D44\u4E00\u89A7'
	    ),
	    _react2.default.createElement(
	      _theme.ProgramCardWrapper,
	      null,
	      programs.map(function (program) {
	        return _react2.default.createElement(_ProgramCard2.default, _extends({}, program, { key: program.id }));
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = ProgramsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-programs-js-1cfeb324f266b6605915.js